import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SignIn from '../SignIn';
import { signInUser } from '../../modules/user/actions';

class SignInContainer extends React.Component {
  constructor() {
    super();

    this.signInUserWrapper = this.signInUserWrapper.bind(this);
  }
  signInUserWrapper(email, password, type) {
    this.props.signInUser(email, password, type, this.props.evaluationId);
  }
  render() {
    return (
      <SignIn
        submitting={this.props.submitting}
        user={this.props.user}
        errorMessage={this.props.errorMessage}
        signInType={this.props.signInType}
        signInUser={this.signInUserWrapper}
        type="results"
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    submitting: state.user.submitting,
    user: state.user.user,
    errorMessage: state.user.error,
    signInType: state.user.signInType,
    evaluationId: state.evaluation.evaluationId,
    language: state.preference.language,
  }
}

const mapActionsToProps = {
  signInUser,
}

export default withRouter(connect(mapStateToProps, mapActionsToProps)(SignInContainer));


// WEBPACK FOOTER //
// ./src/pages/Evaluation/ExistingAccountContainer.js